import { Box, Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const Disclaimer = () => {
    const { address, email } = useSelector(state => state.shop)

    const content = `<h2>Disclaimer</h2>
  <p>
    The information provided by <strong>Localhost</strong> ("we", "us", or "our") on our website and any related platforms or applications is for general informational purposes only.
    All content is provided in good faith; however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, reliability, availability, or completeness of any information.
  </p>
  <p>
    <strong>Under no circumstances shall we be liable for any loss or damage of any kind incurred as a result of the use of our website, platforms, or reliance on any information presented therein.</strong>
    Your use of our services and your reliance on any such information is solely at your own risk.
  </p>
  <p>
    This content does not constitute professional advice of any kind.
  </p>`
    return (
        < Container >
            <Box
                sx={{
                    width: '100%', overflowX: 'auto', mb: 4
                }}
                dangerouslySetInnerHTML={{ __html: content.replace(/Localhost/g, `${window.location.hostname.toUpperCase()}`) }}
            />
            <Typography ><b>Address:</b> {address}</Typography>
            <Typography ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
            <Typography ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
        </Container >
    )
};

export default Disclaimer;
